module.exports = __webpack_public_path__ + "media/cgrt.eef5ada2.mp4";